.footer{position:fixed;bottom:0;width:100%;text-align:center;background-color:#939b9d;font-size:small;height:25px;vertical-align:middle!important}
/*# sourceMappingURL=footer.component-3HJBB2X5.css.map */
